
export const getTitle = (tipo: string): string => {
  switch (tipo) {
    case "tradicional": return "Sistema Tradicional";
    case "mlpe": return "Sistema MLPE";
    case "hibrido": return "Sistema Híbrido";
    case "offgrid": return "Sistema Off-Grid";
    default: return "Sistema Solar";
  }
};

export const getDescription = (tipo: string): string => {
  switch (tipo) {
    case "tradicional": return "Configure os parâmetros do sistema tradicional com inversor string.";
    case "mlpe": return "Configure os parâmetros do sistema com otimizadores ou microinversores (MLPE).";
    case "hibrido": return "Configure os parâmetros do sistema híbrido com banco de baterias.";
    case "offgrid": return "Configure os parâmetros do sistema autônomo sem conexão à rede.";
    default: return "Configure os parâmetros do sistema solar.";
  }
};
